import autoBind from 'react-autobind';
import Avatar from 'material-ui/Avatar';
import CharacterDetailAttribute from './CharacterDetailAttribute';
import {CharacterDetailLessonPlans} from './index';
import CharacterDetailList from './CharacterDetailList';
import {CharacterSymbol} from '../../shared/components';
import {connect} from 'react-redux';
import Divider from 'material-ui/Divider';
import {handleApiError} from '../../shared/services';
import muiTheme from '../../../styles/teamologyTheme';
import RaisedButton from 'material-ui/RaisedButton';
import RetinaImage from 'react-retina-image';
import {Link, withRouter} from 'react-router';
import {List, Map} from 'immutable';
import {loadCardData, loadCharacter} from '../actions';
import {MainContent, Page, PageBody, PageHeader, SideNavigationBar} from '../../layout/components';
import React, {Component, PropTypes} from 'react';

class CharacterDetailPage extends Component {
  constructor(props, context) {
    super(props, context);

    autoBind(this);
  }

  componentDidMount() {
    this.loadData();
  }

  componentDidUpdate(prevProps) {
    const {characterId} = this.props.params;

    if (characterId !== prevProps.params.characterId) {
      this.loadData();
    }
  }

  loadData() {
    const {router, loadCharacter, loadCardData} = this.props;
    const {characterId} = this.props.params;

    loadCharacter(characterId)
      .catch(error => handleApiError(error, router, 'An error occurred while attempting to show the Character detail.', 'Error'));

    loadCardData(characterId)
      .catch(error => handleApiError(error, router, 'An error occurred while attempting to show the Character lesson plans.', 'Error'));
  }

  render() {
    const dividerStyle = {
      marginLeft: -30,
      marginRight: -30,
    };
    const mandateButtonStyle = {
      paddingLeft: 12,
      paddingRight: 12,
      whiteSpace: 'nowrap',
      overflow: 'hidden',
      textOverflow: 'ellipsis'
    };

    const {loading, model, cardData} = this.props;
    const {characterId} = this.props.params;

    const secondaryInformationTitle = model.get('secondaryInformationTitle');
    const pictogramTitle = model.get('pictogramItem') || '';

    const secondaryInformations = model.get('secondaryInformations') || [];
    const sampleBehaviors = model.get('sampleBehaviors') || [];
    const exampleCareers = model.get('exampleCareers') || [];

    const showSecondaryInformation = secondaryInformationTitle && secondaryInformations && secondaryInformations.length > 0;

    const characterColor = model.get('name') ? muiTheme.characterColors[model.get('name').toLowerCase()] : '';
    const characterSymbol = model.get('badgeImageName') ? <CharacterSymbol source={model.get('badgeImageName')} /> : null;

    return (
      <Page pageClassName="character-detail-page">
        <PageHeader title={loading ? '' : `${model.get('name')} / ${model.get('foundationShort')}`} />
        <PageBody>
          <SideNavigationBar />
          <MainContent loading={loading}>
            <div className="character-detail">
              <div className="left-hand">
                <div className="pictogram-item">
                  <div className="pictogram-item-title">{pictogramTitle.toUpperCase()} OF THE HOUSE</div>
                  <div className="pictogram-item-text">{model.get('description')}</div>
                </div>
                {
                  showSecondaryInformation
                    ? <CharacterDetailList title={secondaryInformationTitle.toUpperCase()} items={secondaryInformations} ordered />
                    : <div />
                }
                <CharacterDetailList title="SAMPLE BEHAVIORS" items={sampleBehaviors} ordered={false} />
                <CharacterDetailList title="EXAMPLE CAREERS" items={exampleCareers} ordered={false} />
              </div>
              <div className="right-hand">
                <div className="character-image">
                  {
                    !loading && model.get('detailImageName')
                      ? <RetinaImage src={[require(`../images/${model.get('detailImageName')}.png`), require(`../images/${model.get('detailImageName')}@2x.png`)]} />
                      : <div />
                  }
                </div>
                <div className="character-attributes">
                  <CharacterDetailAttribute title="FOUNDATION" text={model.get('foundationFull')} />
                  <CharacterDetailAttribute title="COLOR" text={model.get('color')} visualAid={<Avatar backgroundColor={characterColor} size={25} />} />
                  <CharacterDetailAttribute title="SYMBOL" text={model.get('symbol')} visualAid={characterSymbol} />
                  <CharacterDetailAttribute title="CAREER PATHWAY" text={model.get('careerPathway')} />
                  <RaisedButton
                    containerElement={<Link to={`/mandates/${characterId}`} />}
                    className="raised-button--rounded"
                    labelStyle={mandateButtonStyle}
                    primary
                    label="Policies, Standards and Mandates" />
                </div>
              </div>
            </div>
            <Divider style={dividerStyle} />
            <div className="lesson-plans">
              <CharacterDetailLessonPlans cardData={cardData} />
            </div>
          </MainContent>
        </PageBody>
      </Page>
    );
  }
}

CharacterDetailPage.propTypes = {
  cardData: PropTypes.instanceOf(List).isRequired,
  loadCardData: PropTypes.func.isRequired,
  loadCharacter: PropTypes.func.isRequired,
  loading: PropTypes.bool.isRequired,
  model: PropTypes.instanceOf(Map).isRequired,
  params: PropTypes.object.isRequired,
  router: PropTypes.object.isRequired,
};

function mapStateToProps(state) {
  const {showCharacter} = state.features.characterDetail.pages;
  const {showLessonPlans} = state.features.characterDetail.pages;

  return {
    cardData: showLessonPlans.get('cardData'),
    loading: showCharacter.get('loading'),
    model: showCharacter.get('character'),
  };
}

export default withRouter(connect(
  mapStateToProps,
  {
    loadCardData,
    loadCharacter,
  }
)(CharacterDetailPage));



// WEBPACK FOOTER //
// ./app/features/characterDetail/components/CharacterDetailPage.js